import React, { Component } from 'react';
import { Grid } from '@mui/material';
import MOBILE_CLASSES from './mobileStylesClasses';
import { withTranslation } from 'react-i18next';
import moment from 'moment';
import clsx from 'clsx';
import { MomentFormats } from '../../../utils';

class ListView extends Component {
    generateBox(classes, boxClass, value) {
        return (<div className={clsx(classes.listViewManagerSettingAmountBox, boxClass)}>{value}</div>);
    }

    generateBoxClasses(day, classes) {
        const {
            availableOpenShifts,
            availableShiftOffers,
            availableVTO,
            employeePaycodes,
            employeeShifts,
            myOpenShiftRequests,
            myProposals,
            mySwapOffers,
            myToCoverOffers,
            myToCoverRequests,
            myVTORequests,
            toCoverOffers,
        } = this.props;

        let boxClasses = [];
        let index = moment(day).format(MomentFormats.YYMMDD);

        let nbMyRequests = 0;
        if (myToCoverOffers[index]) {
            nbMyRequests += myToCoverOffers[index].length;
        }
        if (myToCoverRequests[index]) {
            nbMyRequests += myToCoverRequests[index].length;
        }
        if (mySwapOffers[index]) {
            nbMyRequests += mySwapOffers[index].length;
        }
        if (myProposals[index]) {
            nbMyRequests += myProposals[index].length;
        }
        if (myOpenShiftRequests[index]) {
            nbMyRequests += myOpenShiftRequests[index].length;
        }
        if (myVTORequests[index]) {
            nbMyRequests += myVTORequests[index].length;
        }

        if (employeeShifts[index]) {
            boxClasses.push(this.generateBox(classes, classes.amountBoxShifts, employeeShifts[index].length));
        }
        if (employeePaycodes[index]) {
            boxClasses.push(this.generateBox(classes, classes.amountBoxPaycodes, employeePaycodes[index].length));
        }

        if (nbMyRequests) {
            boxClasses.push(this.generateBox(classes, classes.amountBoxMyRequests, nbMyRequests));
        }
        if (toCoverOffers[index]) {
            boxClasses.push(this.generateBox(classes, classes.amountBoxTC, toCoverOffers[index].length >= 3 ? '3+' : toCoverOffers[index].length));
        }
        if (availableShiftOffers[index]) {
            boxClasses.push(this.generateBox(classes, classes.amountBoxSS, availableShiftOffers[index].length));
        }
        if (availableOpenShifts[index]) {
            boxClasses.push(this.generateBox(classes, classes.amountBoxOS, availableOpenShifts[index].length));
        }
        if (availableVTO[index]) {
            boxClasses.push(this.generateBox(classes, classes.amountBoxVTO, availableVTO[index].length));
        }

        return boxClasses;
    }

    renderMonthsList() {
        let { classes = MOBILE_CLASSES, currentDay, onDayClick } = this.props;

        const startOfMonth = moment(currentDay).startOf("month");
        const endOfMonth = moment(currentDay).endOf("month");

        let now = moment(startOfMonth);
        let daysList = [];

        while (now.isSameOrBefore(endOfMonth)) {
            let boxes = this.generateBoxClasses(now, classes);
            let today = moment(now);
            daysList.push(
                <div className={classes.listViewItem} onClick={() => onDayClick(today)} >
                    <Grid container>
                        <Grid item xs={3} className={classes.listViewDateArea}>
                            <div className={classes.listViewDayOfTheWeek} >{now.format(MomentFormats.dddd)}</div>
                            <div className={classes.listViewDate} >{now.format(MomentFormats.DayOfMonth)}</div>
                        </Grid>
                        <Grid item xs={9} className={classes.listViewBoxesArea}>
                            {boxes}
                        </Grid>
                    </Grid>
                </div>
            );

            now.add(1, "days");
        }

        return <div>{daysList}</div>;
    }

    render() {
        return this.renderMonthsList();
    }
}

export default withTranslation('employmentBillboard')(ListView);
